// Copyright (c) 2025-26, Keyfactor, Inc.
'use strict'

const darkTheme = require('./themes/dark')
const lightTheme = require('./themes/light')

const IMPLEMENTED_THEMES = [
    { id: 'dark', name: 'Dark', theme: darkTheme },
    { id: 'light', name: 'Light', theme: lightTheme },
]

module.exports.getDefaultTheme = () => IMPLEMENTED_THEMES.find(theme => theme.id === 'light')

module.exports.getTheme = themeId => IMPLEMENTED_THEMES.find(theme => theme.id === themeId)

module.exports.imagePath = `${__dirname}/images`
module.exports.imageUrl = '/theme_images'
